import { PdenSourceEnum } from "models/pdenDataSourceSetting";

/**
 * Converts a pdenSource string (e.g. "Public", "101", "") to its numeric enum value.
 *
 * Falls back to PdenSourceEnum.Public (100) for any input that cannot be mapped —
 * including empty strings, undefined/null coerced to string, and unrecognised names.
 * This prevents "NaN" from being serialised into query params and hitting the backend's
 * PdenSource deserialiser (which rejects it with "Unknown PdenSource: NaN").
 */
export function toPdenEnum(source: unknown): number {
  if (typeof source === "string") {
    switch (source.toLowerCase()) {
      case "public":
        return PdenSourceEnum.Public;
      case "private":
        return PdenSourceEnum.Private;
      case "hybrid":
        return PdenSourceEnum.Hybrid;
      case "gdc":
        return PdenSourceEnum.gDC;
      case "aer":
        return PdenSourceEnum.aer;
      case "mcdan":
        return PdenSourceEnum.mcdan;
      case "novi":
        return PdenSourceEnum.novi;
      case "ihs":
        return PdenSourceEnum.ihs;
      default: {
        const parsed = parseInt(source, 10);
        return isNaN(parsed) ? PdenSourceEnum.Public : parsed;
      }
    }
  }

  if (typeof source === "number" && !isNaN(source)) {
    return source;
  }

  return PdenSourceEnum.Public;
}
